import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import RecaptchaService from 'cio/services/recaptcha';
import RouterService from '@ember/routing/router-service';
import ApiService from 'cio/services/api';
import SignupController from 'cio/pods/signup/controller';
import SignupService from 'cio/services/signup';
import SessionService from 'cio/services/session';
import Transition from '@ember/routing/-private/transition';
import { next } from '@ember/runloop';
import FeaturesService from 'ember-feature-flags/services/features';
import AccountService from 'cio/services/account';

export default class SignupRoute extends Route {
  @service account!: AccountService;
  @service recaptcha!: RecaptchaService;
  @service router!: RouterService;
  @service api!: ApiService;
  @service session!: SessionService;
  @service signup!: SignupService;
  @service features!: FeaturesService;

  async beforeModel(transition: Transition) {
    this.session.prohibitAuthentication('authenticated');

    await super.beforeModel(transition);
    return this.recaptcha.loadRecaptcha();
  }

  async model({ category, signupType }: { category: string; signupType?: string }) {
    let validatedSignupType = await this.signup.validateSignupType.perform(signupType);
    let testimonials = await this.signup.getTestimonials.perform(validatedSignupType.name, category);
    return {
      signupType: validatedSignupType,
      testimonials,
    };
  }

  setupController(controller: SignupController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaults();

    // wrapping in "next" avoids some timing error (since changing from using
    // Router.transitionTo to RouterService.transitionTo)
    next(() => {
      this.router.transitionTo('signup.index'); // always start sign-up from step 1
    });
  }
}
